module.exports = __webpack_public_path__ + "static/media/bottom_shape_5.b0a76bfd.svg";